<template>
  <!-- myDiv for add paddingBottom-->
  <div id="myDiv">
    <vs-breadcrumb v-if="userAccount === 'betagrodemo' || admin == 'betagrodemo'">
      <li>
        <a aria-current="page" style="color: #ffffff" title="Device Management"
          >Device Management</a
        ><span style="color: #ffffff" class="vs-breadcrum--separator">/</span>
      </li>
      <li>
        <router-link
          style="color: #ffffff"
          :to="'IndoorGateway'"
          title="IndoorGateway"
          >Gateway</router-link
        ><span class="vs-breadcrum--separator" style="color: #ffffff">/</span>
      </li>
      <li aria-current="page" class="textSuccess">View Gateway</li>
    </vs-breadcrumb>
    <vs-breadcrumb v-else>
      <li>
        <a
          aria-current="page"
          style="color: rgba(0, 0, 0, 0.4)"
          title="Device Management"
          >Device Management</a
        ><span class="vs-breadcrum--separator">/</span>
      </li>
      <li>
        <router-link :to="'IndoorGateway'" title="IndoorGateway"
          >Gateway</router-link
        ><span class="vs-breadcrum--separator">/</span>
      </li>
      <li aria-current="page" class="textSuccess">View Gateway</li>
    </vs-breadcrumb>
    <!-- <pre>{{sensorList}}</pre> -->
    <vs-card style="border-radius: 20px">
      <div class="mt-2" slot="header">
        <h4>
          {{ gateway.name }}
        </h4>
      </div>
      <vs-row vs-w="12">
        <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-lg="4"
          class="p-3"
          vs-sm="4"
          vs-xs="4"
        >
          <img
            src="../../../../assets/images/sensor/IndoorGW.png"
            width="200"
            height="100"
          />
        </vs-col>

        <b-modal
          id="addsensor"
          :no-close-on-backdrop="false"
          hide-header-close
          centered
          hide-footer
          size="lg"
        >
          <template #modal-title>
            <h4 class="textSuccess">Edit Gateway</h4>
          </template>
          <div>
            <AddDevice :mac="gateway.mac" :type="gateway.type" />
          </div>
        </b-modal>

        <vs-col vs-type="flex" vs-align="center" vs-lg="7" vs-sm="7" vs-xs="8">
          <div style="width: 100%">
            <vs-row vs-w="12">
              <vs-col
                class="textRight textResponsive"
                vs-lg="3"
                vs-sm="4"
                vs-xs="4"
              >
                <span class="font-weight-bold">Gateway Name</span>
              </vs-col>
              <vs-col vs-lg="8" vs-sm="8" vs-xs="8">
                <span class="mr-2">{{ gateway.name }}</span>
                <vs-icon
                v-if="this.userAccount == admin &&  this.userAccount == 'unicorndemo' " 
                  icon="edit"
                  color="primary"
                  size="18px"
                  v-b-modal.addsensor
                ></vs-icon>
                 <vs-icon
                v-if=" this.userAccount == 'syntecdemo' " 
                  icon="edit"
                  color="primary"
                  size="18px"
                  v-b-modal.addsensor
                ></vs-icon>
              </vs-col>
            </vs-row>
            <vs-row class="mt-3" vs-w="12">
              <vs-col
                class="textRight textResponsive"
                vs-lg="3"
                vs-sm="4"
                vs-xs="4"
              >
                <span class="font-weight-bold textNowrap">Mac Address</span>
              </vs-col>
              <vs-col vs-lg="8" vs-sm="8" vs-xs="8">
                <span>{{ gateway.mac }}</span>
              </vs-col>
            </vs-row>

            <vs-row class="mt-3" vs-w="12">
              <vs-col
                class="textRight textResponsive"
                vs-lg="3"
                vs-sm="4"
                vs-xs="4"
              >
                <span class="font-weight-bold">Type</span>
              </vs-col>
              <vs-col vs-lg="8" vs-sm="8" vs-xs="8">
                <span> {{ gateway.type }}</span>
              </vs-col>
            </vs-row>
            <vs-row class="mt-3" vs-w="12">
              <vs-col
                class="textRight textResponsive"
                vs-lg="3"
                vs-sm="4"
                vs-xs="4"
              >
                <span class="font-weight-bold">Last Seen</span>
              </vs-col>
              <vs-col vs-lg="8" vs-sm="8" vs-xs="8">
                <span> {{ lastseen }}</span>
              </vs-col>
            </vs-row>
          </div>
        </vs-col>
      </vs-row>
    </vs-card>
    <vs-card style="border-radius: 20px">
      <!-- <div class="mt-2" slot="header">
        <h4>Active Device</h4>
      </div> -->
      <!-- <vs-table :data="sensorList" search>
        <template slot="thead">
         
          <vs-th v-for="item in header" :key="item" sort-key="name" id="noWrap">
            {{ item }}
            <span><vs-icon icon="unfold_more" size="0.75rem"></vs-icon></span>
          </vs-th>
        </template> -->
      <!-- <template slot-scope="{ data }">
          <vs-tr :key="indextr" v-for="(tr, indextr) in data">
            <vs-td :data="data[indextr].name">
              <vs-button
                class="textNowrap"
                @click="viewSensor(indextr)"
                icon="signal_cellular_alt"
                type="flat"
                >{{ data[indextr].name }}</vs-button
              >
            </vs-td>
           
            <vs-td :data="data[indextr].mac">
              {{ data[indextr].mac }}
            </vs-td>
           
            
            <vs-td :data="data[indextr].rssi">
              
              <vs-icon
                icon="fiber_manual_record"
                v-if="data[indextr].active == 1"
                color="primary"
              ></vs-icon>
              <vs-icon
                icon="fiber_manual_record"
                v-else-if="data[indextr].active == 2"
                color="yellow"
              ></vs-icon>
              <vs-icon icon="fiber_manual_record" v-else color="grey"></vs-icon>
            </vs-td>
            <vs-td :data="data[indextr].rssi">
              
              {{ data[indextr].rssi }}
            </vs-td>
            <vs-td :data="data[indextr].bat">
             
              <vs-icon icon="battery_full" color="primary"></vs-icon>
            </vs-td>
          </vs-tr>
        </template> -->
      <!-- </vs-table> -->
    </vs-card>
  </div>
</template>

<script>
import AddDevice from "../Subpage/editGateway.vue";

export default {
  name: "ViewGateway",
  props: ["gateway"],
  data: () => ({
    userAccount: "",
    admin: "",
    serial: "",
    security: "",
    name: "",
    type: "",
    sensorList: [],
    header: [
      "Device Name",
      "Mac Address",
      "Type",
      "Active Status",
      "Signal",
      "Battery",
    ],
    mounted() {
      this.$API.get("indoorgateway/" + this.gateway.mac).then((result) => {
        console.log(result.data);
      });
    },
    sensor: {
      id: null,
      name: null,
      serial: null,
      security: null,
      type: null,
      subtype: null,
    },
    lastseen: "",
    sensorId: [],
    admin: "",
  }),
  components: {
    AddDevice,
  },
  methods: {
    viewSensor(item) {
      console.log(item);
      console.log(this.sensorId[item]);
      this.$API.get("sensors/user").then((result) => {
        console.log(result.data);
        let sensor = result.data.filter(
          (sensor) => sensor.id == this.sensorId[item]
        );
        if (sensor) {
          let item = sensor[0];
          this.$session.set("nwname", item.network);
          this.$session.set("statussensor", item.active);
          this.$session.set("nwid", item.nwid);
          this.$session.set("sensorname", item.name);
          this.$session.set("sensorid", item.serial_id);
          this.$session.set("gatewayid", item.gatewayid);
          this.$session.set("type", item.type);
          this.$session.set("lora", item.lora);
          this.$session.set("id", item.id);
          this.$router.push({
            name: "SensorDashboard",
            params: {
              // nwname: sensor.network,
              nwid: item.nwid,
              sensorid: item.serial_id,
              gatewayid: item.gatewayid,
              type: item.type,
              id: item.id,
            },
          });
        }
      });
    },
  },
  created() {
    console.log(this.gateway)
    this.userAccount = this.$session.get("username");
    this.admin = this.$session.get("username");
    this.$API.get("indoorgateway/" + this.gateway.mac).then((result) => {
      // this.sensorList = result.data;
      result.data[0].tagfound.forEach((element) => {
        console.log(element);
        this.sensorList.push({
          mac: element.mac,
          rssi: element.rssi,
          // found: element.tagfound,
          // notregis: element.notregistered,
          // totalfound: element.totalfound,
          signal: "100",
          bat: "100",
        });
        this.sensorId.push(element.id);
        console.log(this.sensorId);
      });
      console.log(result.data);
      console.log(this.sensorList);
    });
    // this.$API
    //         .get("indoorgateway/"+ this.gateway.mac)
    //         .then((result) => {
    //           console.log(result.data)})

    //   this.$API.get('gatewaysensor/'+this.gateway.networkID+'/'+this.$session.get('token')).then((result) => {
    //   this.sensorList = result.data
    //   console.log(result.data)
    // })
    this.$API
      .post("getlastseen/indoor", {
        gid: this.gateway.mac,
      })
      .then((result) => {
        // console.log(result.data)
        this.lastseen = this.$moment(result.data).format(
          "YYYY-MM-DD HH:mm:ss"
        );
        console.log(this.lastseen)
      });
  },
  mounted() {
    this.admin = this.$session.get("admin")
    switch (this.userAccount || this.admin) {
      case "betagrodemo":
        var elem = document.getElementsByClassName("con-vs-card");
        Array.prototype.filter.call(elem, function (testElement) {
          testElement.style.background = "#212121";
          testElement.style.color = "#FFFFFF";
        });
        var elemtable = document.getElementsByClassName("vs-con-table");
        Array.prototype.filter.call(elemtable, function (testElementtable) {
          testElementtable.style.background = "#212121";
        });
        var elemtableheader = document.getElementsByClassName("vs-list--title");
        Array.prototype.filter.call(
          elemtableheader,
          function (testElementtableheader) {
            testElementtableheader.style.background = "#212121";
            testElementtableheader.style.color = "#FFFFFF";
          }
        );
        document.getElementById("myDiv").style.paddingBottom = "500px";
        break;
      default:
        // console.log("Try looking up for a hint.");
    }
  },
};
</script>
<style scoped>
#noWrap {
  padding: 0px;
  white-space: nowrap;
  font-size: 0.75rem;
}
img {
  max-width: 100%;
  height: auto;
}
.vs-button {
  border-radius: 20px;
}
.textRight {
  text-align: right;
}
@media only screen and (max-width: 530px) {
  .textResponsive {
    text-align: left;
  }
}
</style>